import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

const LoginExtraFieldTwoComponent = () => {
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (RapsEuropeData[0]) {
      let rapsResult = RapsEuropeData[0].result && RapsEuropeData[0].result[0];
      if (rapsResult) {
        setDescription(rapsResult.extraDescriptionFieldTwo);
      }
    }
  }, [RapsEuropeData]);
  
  return (
    <>
      <div id="create-account" className="flex-block" dangerouslySetInnerHTML={{ __html: description }}></div>
    </>
  );
};

export default LoginExtraFieldTwoComponent;
